// Helper function to get transform value
const getTextfieldLabelTransform = size => {
  switch (size) {
    case 'small':
      return 'translate(14px, 12px) scale(1)'
    case 'large':
    case 'medium': // Both large and medium share the same transform
    default:
      return 'translate(14px, 20px) scale(1)'
  }
}

export default getTextfieldLabelTransform
